import { render, staticRenderFns } from "./ScrollableTableWrapper.vue?vue&type=template&id=c2d5b722&"
import script from "./ScrollableTableWrapper.vue?vue&type=script&lang=js&"
export * from "./ScrollableTableWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports